import {createFileRoute} from '@tanstack/react-router';
import {InvoiceAccountPage} from '../../../../../../features/one-time-credit/pages/InvoiceAccountPage/InvoiceAccountPage';

export const Route = createFileRoute(
  '/_protected/home/accounts/one-time-credit/$accountId/',
)({
  component: InvoiceAccountPage,
});
